export default "__VITE_ASSET__CFJMhBIg__"